/*#__NO_SIDE_EFFECTS__*/
const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

export { isBezierDefinition };
//# sourceMappingURL=is-bezier-definition.mjs.map
